<div class="row">
  <div class="col-12 mb-2">
    <table
      datatable
      [dtOptions]="dtOptions"
      [dtTrigger]="dtTrigger"
      class="table table-striped mb-0"
    >
      <thead>
        <tr>
          <td style="width: 5px">Id</td>
          <th>Changed On</th>
          <th>Changed By</th>
          <th>Source</th>
          <th>Contact name</th>
          <th>Contact surname</th>
          <th>Contact number</th>
          <th>Cell</th>
          <th>Email</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let contact of contactDetails">
          <td style="font-size: 12px">{{ contact.id }}</td>
          <td style="font-size: 12px">
            {{ contact.changedOn | date: "MMM d, y, h:mm:ss a" }}
          </td>
          <td style="font-size: 12px">{{ contact.changedBy }}</td>
          <td style="font-size: 12px">{{ contact.source }}</td>
          <td style="font-size: 12px">{{ contact.contactName }}</td>
          <td style="font-size: 12px">{{ contact.contactSurname }}</td>
          <td style="font-size: 12px">{{ contact.contactNumber }}</td>
          <td style="font-size: 12px">{{ contact.cell }}</td>
          <td style="font-size: 12px">{{ contact.email }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="page-title-box">
      <div class="page-title-right">
        <input
          type="button"
          value="Print"
          class="btn btn-success"
          (click)="print()"
        />
        &nbsp;
        <input
          type="button"
          value="Export to CSV"
          class="btn btn-success"
          (click)="DownloadCsv()"
        />
      </div>
    </div>
  </div>
</div>
